// export const BASE_URL = "http://localhost/apiseq/api/v1/"
//  export const BASE_URL = "http://52.66.213.165:4000/api/"
export const BASE_URL = "https://qmstest.motion.ac.in/apiseq/api/v1/"
 